export const isTruthy = (value) => !!value;
export const isFalsy = (value) => !value;
export const isPropertyTruthy = (property) => (value) => !!value[property];
export const isPropertyFalsy = (property) => (value) => !value[property];
export const arePropertiesTruthy = (...properties) => (value) => properties.every((property) => !!value[property]);
export const arePropertiesFalsy = (...properties) => (value) => properties.every((property) => !value[property]);
